// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/store_cart/v1/store_cart.proto (package fingertip.creator.store_cart.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { AddStoreCartItemPublicRequest, AddStoreCartItemPublicResponse, EmptyStoreCartItemsPublicRequest, EmptyStoreCartItemsPublicResponse, GetStoreCartPublicRequest, GetStoreCartPublicResponse, GetStoreCartRequest, GetStoreCartResponse, GetStoreCartsRequest, GetStoreCartsResponse, RemoveStoreCartItemPublicRequest, RemoveStoreCartItemPublicResponse, SetStoreCartTipPublicRequest, SetStoreCartTipPublicResponse, UpdateStoreCartCommentsPublicRequest, UpdateStoreCartCommentsPublicResponse, UpdateStoreCartItemPublicRequest, UpdateStoreCartItemPublicResponse, UpdateStoreCartPublicRequest, UpdateStoreCartPublicResponse } from "./store_cart_pb.js";

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.GetStoreCartPublic
 */
export const getStoreCartPublic = {
  localName: "getStoreCartPublic",
  name: "GetStoreCartPublic",
  kind: MethodKind.Unary,
  I: GetStoreCartPublicRequest,
  O: GetStoreCartPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.UpdateStoreCartPublic
 */
export const updateStoreCartPublic = {
  localName: "updateStoreCartPublic",
  name: "UpdateStoreCartPublic",
  kind: MethodKind.Unary,
  I: UpdateStoreCartPublicRequest,
  O: UpdateStoreCartPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.UpdateStoreCartCommentsPublic
 */
export const updateStoreCartCommentsPublic = {
  localName: "updateStoreCartCommentsPublic",
  name: "UpdateStoreCartCommentsPublic",
  kind: MethodKind.Unary,
  I: UpdateStoreCartCommentsPublicRequest,
  O: UpdateStoreCartCommentsPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.AddStoreCartItemPublic
 */
export const addStoreCartItemPublic = {
  localName: "addStoreCartItemPublic",
  name: "AddStoreCartItemPublic",
  kind: MethodKind.Unary,
  I: AddStoreCartItemPublicRequest,
  O: AddStoreCartItemPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.SetStoreCartTipPublic
 */
export const setStoreCartTipPublic = {
  localName: "setStoreCartTipPublic",
  name: "SetStoreCartTipPublic",
  kind: MethodKind.Unary,
  I: SetStoreCartTipPublicRequest,
  O: SetStoreCartTipPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.UpdateStoreCartItemPublic
 */
export const updateStoreCartItemPublic = {
  localName: "updateStoreCartItemPublic",
  name: "UpdateStoreCartItemPublic",
  kind: MethodKind.Unary,
  I: UpdateStoreCartItemPublicRequest,
  O: UpdateStoreCartItemPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.RemoveStoreCartItemPublic
 */
export const removeStoreCartItemPublic = {
  localName: "removeStoreCartItemPublic",
  name: "RemoveStoreCartItemPublic",
  kind: MethodKind.Unary,
  I: RemoveStoreCartItemPublicRequest,
  O: RemoveStoreCartItemPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.EmptyStoreCartItemsPublic
 */
export const emptyStoreCartItemsPublic = {
  localName: "emptyStoreCartItemsPublic",
  name: "EmptyStoreCartItemsPublic",
  kind: MethodKind.Unary,
  I: EmptyStoreCartItemsPublicRequest,
  O: EmptyStoreCartItemsPublicResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.GetStoreCart
 */
export const getStoreCart = {
  localName: "getStoreCart",
  name: "GetStoreCart",
  kind: MethodKind.Unary,
  I: GetStoreCartRequest,
  O: GetStoreCartResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};

/**
 * @generated from rpc fingertip.creator.store_cart.v1.StoreCartService.GetStoreCarts
 */
export const getStoreCarts = {
  localName: "getStoreCarts",
  name: "GetStoreCarts",
  kind: MethodKind.Unary,
  I: GetStoreCartsRequest,
  O: GetStoreCartsResponse,
  service: {
    typeName: "fingertip.creator.store_cart.v1.StoreCartService"
  }
};
